import { render } from "./SubmissionDetails.vue?vue&type=template&id=424c6b5a&scoped=true"
import script from "./SubmissionDetails.vue?vue&type=script&lang=js"
export * from "./SubmissionDetails.vue?vue&type=script&lang=js"

import "./SubmissionDetails.vue?vue&type=style&index=0&id=424c6b5a&scoped=true&lang=css"

import exportComponent from "/Users/yunlian/Documents/ccar.fun/purepay/new-pay3-cs-frontweb/new-pay3-cs-frontweb2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-424c6b5a"]])

export default __exports__